import React from "react"
import { Link, graphql } from "gatsby"
import Image from "gatsby-image"

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"

import ArrowIcon from "../../images/arrow-circle-right.svg"

const allservices = ({ content }) => {
  return (
    <section className="pt-36 pb-80 bg-black">
      <div className="container pb-28">
        <h4 className="text-sm text-white">Services</h4>
        <h2 className="text-mobmd lrg:text-xl text-white py-7">
          Video Production is at the core of everything we do
        </h2>
        <Link
          to="/services"
          itemProp="url"
          className="flex z-50"
          style={{ width: "fit-content" }}
        >
          <span className="block pr-3 underline text-white text-sm">
            View all services
          </span>
          <img src={ArrowIcon} />
        </Link>
      </div>

      <div className="carousel-offset">
        <Swiper
          modules={[Navigation]}
          className="bg-black"
          tag="div"
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            500: {
              slidesPerView: 3,
            },
          }}
          navigation
        >
          {content.allServices.map((servicePost, i) => {
            const thumbnail = {
              fluid:
                servicePost.featuredImage?.node?.localFile?.childImageSharp
                  ?.fluid,
              alt: servicePost.featuredImage?.node?.altText || ``,
            }
            return (
              <SwiperSlide className="">
                <Link to={servicePost.uri} itemProp="url">
                  <Image
                    fluid={thumbnail.fluid}
                    alt={thumbnail.alt}
                    className="h-96 lrg:h-136"
                  />
                  <h3 className="text-white text-mobmd underline mt-7">
                    {servicePost.title}
                  </h3>
                </Link>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </section>
  )
}

export default allservices
